import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/common/hooks/useAuth.ts';
import LoadingSpinner from '@/app/common/components/LoadingSpinner.tsx';
import type { ReactNode } from 'react';

export default function PublicRoute({ children }: { children: ReactNode }) {
  const { isLoggedIn, user, logout } = useAuth();

  if (isLoggedIn === null) return <LoadingSpinner />;

  if (isLoggedIn && user?.isDemoUser) {
    logout();
    return <LoadingSpinner />;
  }

  if (isLoggedIn) return <Navigate to="/" replace />;

  return <>{children}</>;
}
